angular.module('ihestiaRestServicesBase')
   .factory('policyOperationsSvc', [ 'IHestiaRestServiceAbstractDef',
    function(IHestiaRestServiceAbstractDef) {

    var PolicyOperations = function()
    {
      IHestiaRestServiceAbstractDef.apply(this, arguments);

      this.resource = 'policyOperations';
      this.businessArea = 'insurance';
    };

    return new PolicyOperations();
  }])
;